<div class="root-wrapper" *ngIf="train; else noTrain">
  <div class="actions-wrapper">
    <qm-element-actions
      *ngIf="currentFeature.id === train?._id"
      [selectedFeature]="currentFeature"
      [selectedLayer]="currentFeature.layer"
      [visibleButtons]="{info: false, flag: true, focus: true}">
    </qm-element-actions>
  </div>
  <ngb-tabset [activeId]="openTab">
    <ngb-tab id="schedule">
      <ng-template ngbTabTitle>
        {{'Timetable' | translate}}
      </ng-template>
      <ng-template ngbTabContent>
        <qm-train-schedule [train]="train"></qm-train-schedule>
      </ng-template>
    </ngb-tab>
    <ngb-tab *ngIf="train && train.type === 'FREIGHT' && hasPermission('cargo-manifest')" id="cargomanifest">
      <ng-template ngbTabTitle>
        {{'Cargo' | translate}}
      </ng-template>
      <ng-template ngbTabContent>
        <qm-vrgroup-cargo-manifest [train]="train"></qm-vrgroup-cargo-manifest>
      </ng-template>
    </ngb-tab>
    <ngb-tab id="dependencies" *qmAuth="'equipment-rotation'">
      <ng-template ngbTabTitle>
        <ng-container *ngIf="trainConflictAlarms.length">
          <i class="fal fa-exclamation-triangle exclamation-icon"></i>
        </ng-container>
        {{'Stock' | translate}}
      </ng-template>
      <ng-template ngbTabContent>
        <qm-vrgroup-train-dependencies [train]="train"></qm-vrgroup-train-dependencies>
      </ng-template>
    </ngb-tab>
    <ngb-tab id="personel" *qmAuth="'personnel-rotation'">
      <ng-template ngbTabTitle>
        <ng-container *ngIf="shiftConflictAlarms.length">
          <i class="fal fa-exclamation-triangle exclamation-icon"></i>
        </ng-container>
        {{'Personnel' | translate}}
      </ng-template>
      <ng-template ngbTabContent>
        <qm-timeline-chart [train]="train" [shiftConflictAlarms]='shiftConflictAlarms'></qm-timeline-chart>
      </ng-template>
    </ngb-tab>
    <ngb-tab id="info">
      <ng-template ngbTabTitle>
        {{'Info' | translate}}
      </ng-template>
      <ng-template ngbTabContent>
        <qm-vrgroup-train-details [train]="train"></qm-vrgroup-train-details>
      </ng-template>
    </ngb-tab>
    <!--
    <ngb-tab>
      <ng-template ngbTabTitle>
        {{'Composition' | translate}}
      </ng-template>
      <ng-template ngbTabContent>
        <qm-vrgroup-train-compositions [train]="train"></qm-vrgroup-train-compositions>
      </ng-template>
    </ngb-tab>
    -->
    <ngb-tab id="timeline">
      <ng-template ngbTabTitle>
        {{'Timeline' | translate}}
      </ng-template>
      <ng-template ngbTabContent>
        <qm-element-timeline [currentFeature]="currentFeature"></qm-element-timeline>
      </ng-template>
    </ngb-tab>
  </ngb-tabset>
</div>
<ng-template #noTrain>
  {{"This train doesn't run on the selected day." | translate}}
</ng-template>

<ng-template #titleTemplate>
  <ng-container *ngIf="train; else titleNoTrain">
    <ng-container *ngIf="$any(train).label; else noLabel">{{$any(train).label}}</ng-container>
    <ng-template #noLabel>{{train.category}} {{train.tripNumber}} {{train.depStation}} - {{train.arrStation}}</ng-template>
  </ng-container>
  <ng-template #titleNoTrain>
    {{tripNumber}} ({{"doesn't run" | translate}})
  </ng-template>
  <!-- need to stop mousedown because otherwise the draggable title bar cancels the click -->
  <div *ngIf="date" class="title-date-picker" (mousedown)="$event.stopPropagation()">
    <input
      type="hidden"
      ngbDatepicker
      [markDisabled]="datepickerDateDisabled"
      outsideDays="collapsed"
      #datePicker="ngbDatepicker"
      [ngModel]="date"
      (click)="datePicker.toggle()"
      (dateSelect)="changeDate($event)"
      class="form-control-plaintext form-control-sm"
      readonly
    >
    <a href="#" (click)="$event.preventDefault(); datePicker.toggle()" class="date-link">
      {{date.day}}.{{date.month}}.{{date.year}}&nbsp;&#9660; <!-- triangle pointing down -->
    </a>
  </div>
</ng-template>
